import { Controller } from "@hotwired/stimulus"

// Live "Selected scope" total + count for the customer estimate-approval page.
// Mirrors Estimate#total (subtotal + tax on taxable items) as line items toggle,
// and blocks an empty selection from silently approving the full estimate.
export default class extends Controller {
  static targets = ["item", "total", "count", "submit"]
  static values = { taxRate: Number }

  connect() {
    this.update()
  }

  update() {
    const items = this.itemTargets
    const checked = items.filter(cb => cb.checked)
    const rate = this.hasTaxRateValue ? this.taxRateValue : 0

    let subtotal = 0
    let tax = 0
    checked.forEach(cb => {
      const price = parseFloat(cb.dataset.price) || 0
      subtotal += price
      if (cb.dataset.taxable === "true") tax += price * rate
    })
    const total = subtotal + tax

    if (this.hasTotalTarget) {
      this.totalTarget.textContent = total.toLocaleString("en-US", { style: "currency", currency: "USD" })
    }

    if (this.hasCountTarget) {
      const noun = items.length === 1 ? "item" : "items"
      this.countTarget.textContent = `${checked.length} of ${items.length} ${noun} selected`
    }

    if (this.hasSubmitTarget) {
      const empty = checked.length === 0
      this.submitTarget.disabled = empty
      this.submitTarget.classList.toggle("opacity-40", empty)
      this.submitTarget.classList.toggle("cursor-not-allowed", empty)
    }
  }
}
